import React, { Component } from 'react';
import Files from 'react-files';
import { SizeMe } from 'react-sizeme';
import cx from 'classnames';
import { Link, Text } from '../../../../../ui-kit';
import { mediaSizes } from '../../../constants';
import '../styles/_drop-zone.scss';

const MIN_FILE_SIZE = 0;
const FILE_SIZE_MULTIPLIER = 10000000000;
const MAX_FILE_SIZE_GB = 10 * FILE_SIZE_MULTIPLIER;











export default class DropZone extends Component {


  onFilesChange = (files) => {
    const { addFileToQueue, closeDropZone } = this.props;

    Array.from(files).forEach((file) => {
      addFileToQueue({ file });

      this._filePickerRef.removeFiles();
    });
    closeDropZone();
  };

  setFilePickerRef = (ref) => {
    if (this._filePickerRef || !ref) {
      return;
    }

    const { filePickerRefCallBack } = this.props;

    this._filePickerRef = ref;

    filePickerRefCallBack(ref);
  };

  handleUploadClick = () => {
    if (!this._filePickerRef) {return;}

    this._filePickerRef.openFileChooser();
  };

  render() {
    const { isVisible, handleDragOut } = this.props;
    return (
      <SizeMe>
        {({ size }) =>
        <div
          className="library-drop-zone__container"
          onDragLeave={handleDragOut}>

            <Files
            className={cx('library-drop-zone', {
              'library-drop-zone--hidden': !isVisible,
              'library-drop-zone--small': size.width < mediaSizes.small
            })}
            dropActiveClassName="library-drop-zone--active"
            onChange={this.onFilesChange}
            accepts={void 0}
            multiple
            maxFileSize={MAX_FILE_SIZE_GB}
            minFileSize={MIN_FILE_SIZE}
            ref={this.setFilePickerRef}
            clickable={false}>


              <Text
              heading4
              prefixIcon="importI"
              prefixIconColor="regent"
              prefixSize={32}
              className="library-drop-zone__text-info">

                Drag & drop assets directly to media library here or &nbsp;
                <Link
                className="library-drop-zone__browse-link"
                onClick={this.handleUploadClick}>

                  browse &nbsp;
                </Link>
                computer
              </Text>
            </Files>
          </div>}

      </SizeMe>);

  }
}